module.exports = __webpack_public_path__ + "static/media/marisa2.0a287d8c.mp3";